module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('h1', {
    staticClass: "calibre29",
    attrs: {
      "id": "calibre_pb_32"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "_Toc29478524"
    }
  }, [_c('span', {
    staticClass: "calibre30"
  }, [_vm._v("Chapter Seven")]), _c('br', {
    staticClass: "calibre31"
  }), _c('span', {
    staticClass: "calibre32"
  }, [_vm._v("Hirayu Onsen")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre33"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("While The Seeker strolled the winding road from the bus depot into the small mountain village, questions rolled about inside his head.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Unless the Politburo earned moral authority from its citizens via an election, it could never truly engage in world dialogue. He had studied the historical transcripts of the Summit Meeting during the early days of detente between the American Reagan and the Soviet Gorbachev. From those readings, The Seeker had learned that the virtuous perspective was always on the Americans’ side. Where Gorbachev represented an aging and out of touch Politburo,")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("President Reagan could always call on the election as proof that he spoke for three hundred million citizens. How does China get that moral authority and remain what they are, a nation with a single ruling party?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("If the Chinese played the board game Go correctly -- on the world stage where it was meant to be played")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("-- they could surround the enemy with over one billion people. He just had to get the Politburo to think in a different way. His smile vanished with the realization of the likelihood of that happening.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("When The Seeker arrived at his hotel, the concierge bowed deeply. Being one of the higher end hotels, he found the ambience to his liking, quiet, spacious, and with a spectacular view. It would no doubt meet his every need.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("A lovely Japanese woman in her mid-twenties dressed in a traditional kimono approached the concierge’s desk. She gestured for The Seeker to follow and struggled with his suitcase, all the while politely ignoring his efforts to help. Passing a large dining area, picture windows revealed a lush courtyard where light snow was turning the winding garden path white. Two partially frozen waterfalls tumbled between red maple trees. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He followed his hostess to the penthouse. It had been decided by the Politburo that even though this was a working vacation, he still represented China and this suite was appropriate to his position. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("By design, a small rock and sand garden")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("was positioned just inside the door of his spacious room. Sliding off his slippers, he stepped onto the tatami mats. The suite was emptier than he had expected, containing only a low table and two low chairs. His hotel guide opened a sliding panel to another room revealing a simple nook displaying a black lacquered vase and a single purple orchid.")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He admired its perfection")]), _c('span', {
    staticClass: "calibre33"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("She then gestured for him to sit as she scurried about silently opening and closing cupboards. The fifty-inch HD screen was hidden discreetly behind panels, as was the computer, safe, courtesy bar, and closet with his dinner robe.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("While she made tea at the table, The Seeker watched and she, in turn, avoided eye contact while giving personal attention to her guest -- a rare ability indeed. He continued with the charade of not understanding her language, offering only the occasional mispronounced word. She then stood and bowed before quietly leaving. The Seeker ignored his")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("responsibility to connect with the Internet and contact China. Instead, he savored his tea. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("After unpacking, he followed the hotel signs to the outdoor hot springs. The male change room was a small log structure set discreetly within a private, forested area. After showering, as was the Japanese custom, he took a small towel used for modesty and followed the stone steps to the onsen. Steam rose from the springs before he actually saw the water frothing from its natural surroundings.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("A distinguished Japanese gentleman and a younger man were having a hushed conversation and The Seeker bowed slightly in their direction before slipping into the steaming water. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The view was breathtaking. A deep valley sliced through the Alps allowing patrons to gaze deeper into Japan. The mountains on either side were shrouded in clouds, but a light breeze was just enough to make them swirl, changing the")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("ambience every few minutes.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The Seeker had given the other two bathers privacy but could still hear what they were discussing. Being unnoticed was his forte, and while relaxing in the heated water, he was intrigued by what was overheard. The Seeker moved further away pretending to get a better angle on the view, thus encouraging the strangers to continue their conversation. They were obviously engineers, and despite his expert grasp of Japanese, some of the technical terms eluded him. However, he did understand enough to know that they were talking about investing millions into green technology. Also, they shared his love of the ancient Japanese game of Go -- this might be useful information.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Removing a ladle from a small wooden barrel, The Seeker made a mental note of their faces while scooping water and pouring it over his head, causing steam to rise from his shoulders. Even though he sat far enough away to miss the odd word, he concluded that he wanted very much to talk to these men. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Within the coming decade, China")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("would rival and possibly even surpass the United States militarily. The economy was already larger than America’s and was growing. The Seeker was determined not to waste China’s wealth on stupid wars like the arrogant Americans who squandered something like three trillion dollars and accomplished nothing. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The Seeker was determined that if his China were given the opportunity, national treasure would not be wasted on bullets, but invested into green energy. Then, if he had his way, he would try to make the ruling Committee understand that they should simply give their discoveries to the poor. This would bring great influence and with that would come true power…moral authority. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Working against his thinking was not only the Second-in-Command, but also the older members of the Politburo. Still, The Seeker had one advantage; the rapid rise of China had been wholly unanticipated and the ruling Overlords did not really know how to handle their wealth. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Empires came and went, and as technology increased, these empires now rose and fell over decades, not millennia. Each empire lasted a shorter amount of time than the previous; America was already in decline because they had based their faith mostly on the military industrial complex. If he had his way, China would base thinking not on destiny, but deeds, not on the military, but on having a relationship with the rest of the world and the influence that would come with that relationship.    ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("As the")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("engineers rose out of the water, they acknowledged The Seeker with a polite nod. Returning their greeting, he knew that a decision had to be made quickly — leave with them at this very moment, or trust that they")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("might meet again. He remained. After all, there were limited restaurants and bars in the small mountain village and the snow was falling heavier. He gambled that they would not be leaving the hotel anytime soon. The Seeker had learned that patience was a virtue and to take time to strategize on how to approach these gentlemen would ultimately lead to success.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_33"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0872b9fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_010.vue
// module id = 90
// module chunks = 0